import React from 'react';
// eslint-disable-next-line no-restricted-imports
import NextLink from 'next/link';
import { Link } from '@chakra-ui/react';

// eslint-disable-next-line no-restricted-imports
import type { LinkProps } from 'next/link';
import type { LinkProps as ChakraLinkProps } from '@chakra-ui/react';

type NavLinkNextLinkProps = {
  href: LinkProps['href'];
  prefetch?: boolean;
};

type NavLinkChakraLinkProps = {
  children: React.ReactNode;
  variant?: 'default' | 'table' | 'navigation';
};

export type NavLinkProps = NavLinkNextLinkProps & NavLinkChakraLinkProps & Omit<ChakraLinkProps, 'href' | 'variant'>;

/**
 * NavLink - A client-side navigation link component that uses Next.js Link with a Chakra UI Link.
 */
export const NavLink = ({ href, prefetch, children, variant, ...rest }: NavLinkProps) => {
  return (
    <NextLink href={href} prefetch={prefetch} passHref legacyBehavior>
      <Link variant={variant} {...rest}>
        {children}
      </Link>
    </NextLink>
  );
};

NavLink.displayName = 'NavLink';
